import React from "react";
import "./Skills.css";
import python from "./assets/python.svg";
import c from "./assets/c.svg";
import cpp from "./assets/cpp.svg";
import html from "./assets/html5.svg";
import javascript from "./assets/javascript.svg";
import arduino from "./assets/arduino.svg";
import css from "./assets/css.svg";
import docker from "./assets/docker.svg";
import express from "./assets/express.svg";
import firebase from "./assets/firebase.svg";
import flask from "./assets/flask.svg";
import git from "./assets/git.svg";
import linux from "./assets/linux.svg";
import matlab from "./assets/matlab.svg";
import mongodb from "./assets/mongodb.svg";
import mysql from "./assets/mysql.svg";
import nextjs from "./assets/nextjs.svg";
import nodejs from "./assets/nodejs.svg";
import postgresql from "./assets/postgresql.svg";
import raspberrypi from "./assets/raspberrypi.svg";
import reactjs from "./assets/react.svg";

const skillCategories = [
  {
    title: "Programming, Scripting, and Markup Languages",
    skills: [
      { name: "Python", icon: python },
      { name: "C", icon: c },
      { name: "C++", icon: cpp },
      { name: "HTML", icon: html },
      { name: "JavaScript", icon: javascript },
      { name: "CSS", icon: css },
    ],
  },
  {
    title: "Web Frameworks and Technologies",
    skills: [
      { name: "Flask", icon: flask },
      { name: "Node.js", icon: nodejs },
      { name: "Next.js", icon: nextjs },
      { name: "React.js", icon: reactjs },
      { name: "Express.js", icon: express },
    ],
  },
  {
    title: "Database and Hardware Technologies",
    skills: [
      { name: "PostgreSQL", icon: postgresql },
      { name: "Raspberry Pi", icon: raspberrypi },
      { name: "Arduino", icon: arduino },
      { name: "Firebase", icon: firebase },
      { name: "MySQL", icon: mysql },
    ],
  },
  {
    title: "Other Tools and Libraries",
    skills: [
      { name: "Docker", icon: docker },
      { name: "Git", icon: git },
      { name: "Linux", icon: linux },
      { name: "MATLAB", icon: matlab },
      { name: "MongoDB", icon: mongodb },
    ],
  },
];

function Skills() {
  return (
    <div className="skills-section">
      <div className="skills-container">
        <h1 className="skills-header">Skills</h1>
        <p className="skills-description">
          Here is the tech stack I've previously worked with :)
        </p>

        {skillCategories.map((category, index) => (
          <div key={index} className="skill-category">
            <h3 className="skill-header">{category.title}</h3>
            <div className="skills-row">
              {category.skills.map((skill, i) => (
                <div key={i} className="skill">
                  <div className="icon">
                    <img src={skill.icon} alt={skill.name} />
                  </div>
                  <div className="skill-name">{skill.name}</div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Skills;
